import React, { useContext, useEffect, useState } from "react";
import "./homepage.css";
import { useScreenTransition } from "../../Hooks/useScreenTransition";

import { ReactComponent as Frame1 } from "../../assets/home/Frame1.svg";
import { ReactComponent as Frame2 } from "../../assets/home/Frame2.svg";
import { ReactComponent as Group2 } from "../../assets/home/Group2.svg";
import { ReactComponent as Listbox } from "../../assets/home/Listbox.svg";
import mexicoFlag from "../../assets/flags/mexicoFlag.png";
import germanyFlag from "../../assets/flags/germanyFlag.png";
import USAFlag from "../../assets/flags/USAFlag.png";

import { DataContext } from "../../Context/DataContext";
import { AuthContext } from "../../Context/AuthContext";

const HeroSection = () => {
  const { transitionTo } = useScreenTransition();

  const { signedIn } = useContext(AuthContext);
  const { userData, order, setOrder } = useContext(DataContext);

  const gotoOrder = () => {
    if (!signedIn) {
      transitionTo("/order/type");
      return;
    }
    if (signedIn && (userData.accountType === "personal" || !userData.teamId)) {
      transitionTo("/order/documents");
      localStorage.setItem(
        "order",
        JSON.stringify({ ...order, type: "personal" })
      );
      setOrder((q) => ({ ...q, type: "personal" }));
    } else if (
      signedIn &&
      (userData.accountType === "business" || userData.teamId)
    ) {
      transitionTo("/order/documents");
      localStorage.setItem(
        "order",
        JSON.stringify({ ...order, type: "business" })
      );
      setOrder((q) => ({ ...q, type: "business" }));
    }

    // Fixing incorrect logical conditions
  };

  const subTitle = [
    { title: "Government", color: "#F46350" },
    { title: "Courts", color: "#4EC1D0" },
    { title: "Universities", color: "#845CEF" },
    { title: "USCIS", color: "#F46350" },
  ];

  const [currentIndex, setCurrentIndex] = useState(0);
  const [text, setText] = useState("");
  const [isDeleting, setIsDeleting] = useState(false);

  useEffect(() => {
    const currentTitle = subTitle[currentIndex].title;
    const typingSpeed = isDeleting ? 100 : 200;
    const timeout = setTimeout(() => {
      if (!isDeleting && text === currentTitle) {
        setTimeout(() => setIsDeleting(true), 2000);
      } else if (isDeleting && text === "") {
        setIsDeleting(false);
        setCurrentIndex((prevIndex) => (prevIndex + 1) % subTitle.length);
      } else {
        setText(
          isDeleting
            ? currentTitle.substring(0, text.length - 1)
            : currentTitle.substring(0, text.length + 1)
        );
      }
    }, typingSpeed);

    return () => clearTimeout(timeout);
  }, [text, isDeleting, currentIndex, subTitle]);
  return (
    <div className="mt-20 text-center px-2 relative">
      <div className="absolute bg-white sm:hidden flex justify-center items-center p-3 rounded-full z-20 -top-6 -right-6 shadow-md">
        <img src={germanyFlag} alt="Flag" className="h-10 w-10" />
      </div>

      <div className="space-y-10">
        <div>
          <h1 className="font-secondary text-white font-medium md:text-7xl text-5xl uppercase w-full md:p-0 px-8 leading-[1.2]">
            Certified Translations Services For
          </h1>
          <div className="font-secondary font-medium md:text-7xl text-5xl uppercase w-full flex justify-center items-center mt-2 md:min-h-[4.5rem] min-h-[3rem]">
            <h1 style={{ color: subTitle[currentIndex].color }}>{text}</h1>
          </div>
        </div>

        <div className="space-y-1">
          <p className="text-[#BDC1C9] text-base">
            Get your certified translations delivered in under{" "}
          </p>
          <p className="text-white text-base font-bold">
            24 hours for just $24.95/page
          </p>
        </div>

        <div className="w-full justify-center flex sm:flex-row flex-col md:gap-6 gap-4 px-2">
          <button
            className="bg-primary text-white px-10 py-2 rounded-full hover:opacity-80 font-semibold  whitespace-nowrap"
            onClick={(e) => gotoOrder(e)}
          >
            Create Order
          </button>
          <button
            className="px-10 py-2 rounded-full hover:opacity-80 border-2 border-white text-white font-semibold  whitespace-nowrap"
            onClick={(e) => transitionTo("/quote/details", e)}
          >
            Free Quote
          </button>
        </div>
      </div>

      <div className=" container  justify-center gap-4 lg:mt-32 mt-10 relative mx-auto flex  w-full">
        <Frame1 className="max-h-full max-w-full  bg-cover bg-no-repeat lg:block hidden" />

        <div className="relative sm:block hidden">
          <Frame2 className="max-h-full max-w-full  bg-cover bg-no-repeat" />
          <div className="absolute bg-white lg:hidden flex justify-center items-center p-4 rounded-full z-20 -top-6 -left-6 shadow-md">
            <img src={USAFlag} alt="Flag" className="h-10 w-10" />
          </div>
          <div className="absolute bg-white lg:hidden flex justify-center items-center p-3 rounded-full z-20 -bottom-6 -right-6 shadow-md">
            <img src={mexicoFlag} alt="Flag" className="h-10 w-10" />
          </div>
        </div>

        <div className="relative sm:hidden block">
          <Listbox className="max-h-full max-w-full  bg-cover bg-no-repeat" />
          <div className="absolute bg-white lg:hidden flex justify-center items-center p-3 rounded-full z-20 -top-6 -left-8 shadow-md">
            <img src={USAFlag} alt="Flag" className="h-10 w-10" />
          </div>
        </div>

        <div className="absolute bg-white lg:flex hidden justify-center items-center p-4 rounded-full z-20 -top-6 left-[53%] shadow-md">
          <img src={USAFlag} alt="Flag" className="h-10 w-10" />
        </div>

        <div className="absolute -top-1/2 lg:block hidden">
          <div className="w-full relative">
            <div className="absolute bg-white flex justify-center items-center p-3 rounded-full z-50 top-12 left-6 shadow-md">
              <img src={germanyFlag} alt="Flag" className="h-8 w-8" />
            </div>
            <div className="absolute bg-white flex justify-center items-center p-3 rounded-full z-50 bottom-12 right-6 shadow-md">
              <img src={mexicoFlag} alt="Flag" className="h-8 w-8" />
            </div>
            <Group2 className="z-40 max-h-full max-w-full bg-cover bg-no-repeat" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeroSection;
